export default "__VITE_ASSET__BPRWv5xh__"